import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import MultipleMenuSection from '../MultipleMenuSection'

import { getIDs, getNames } from '../../helpers/parse'
import { selectTaskPriority, fetchPriorities } from '@SonarCX/slices/priority'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type PriorityFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const PriorityFilter: React.FC<PriorityFilterProps> = props => {
  const dispatch = useAppDispatch()

  const { priorities, loaded, loading } = useAppSelector(selectTaskPriority)

  const { state, handleChange } = useTaskFilters()

  // Fetch priorities if not loaded
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchPriorities())
    }
  }, [loaded, loading, dispatch])

  return (
    <MultipleMenuSection
      title='Priorities'
      options={getIDs(priorities)}
      value={state.priorityValue}
      setValue={handleChange('priorityValue')}
      transform={getNames(priorities)}
      unassignedOpt='All Priorities'
      {...props}
    />
  )
}

export default PriorityFilter
